export const socialsData = {
    github: 'https://github.com/itzkavindu',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/kavindu-nimsara-ba1365311',
    instagram: 'https://www.instagram.com/kavi_.nd',
    // codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/Itzkavindu',
    reddit: 'https://www.reddit.com/user/EviLKaVinDU',
    // blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@kavinduakasid',
    stackOverflow: 'https://medium.com/@kavinduakasid',
    // gitlab: 'https://gitlab.com/',
    youtube: 'https://www.youtube.com/@kavindulk'
}